import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const WarningCircleOutlineIcon = createIcon({
  displayName: 'WarningCircleOutlineIcon',
  path: [
    <path
      d='M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path d='M11 7h2v7h-2zm0 8h2v2h-2z' fill='currentColor' />
  ],
  defaultProps: defaultProps
})
